import Client from '@/hexapla-core/client'
import { Contributor } from '@/hexapla-core/domains/accounts/schema'

/** Which app a session is for: each keeps its own (the portal's is the default). */
export type SessionApp = 'portal' | 'labs'

export interface AuthRequest {
  username: string
  password: string
  app?: SessionApp
}

export interface AuthResponse {
  contributor: Contributor
  token: string
  /** Server-computed book scope; null means unrestricted (admins). */
  scoped_book_ids?: number[] | null
}

export interface Auth {
  login: (apiURL: string, username: string, password: string) => void
  logout: (apiURL: string) => void
}

export const login = (
  apiURL: string,
  username: string,
  password: string,
  app?: SessionApp
): Promise<AuthResponse> => {
  return Client.post<AuthRequest, AuthResponse>(`${apiURL}/api/login`, { username, password, ...(app ? { app } : {}) })
}

export const logout = (apiURL: string) => {
  return Client.get(`${apiURL}/api/logout`)
}

export default { login, logout } as Auth
